import { ReactQuillProps, Quill } from "react-quill";
import styled from "styled-components";
import { ImageActions } from "@xeger/quill-image-actions";
import { ImageFormats } from "@xeger/quill-image-formats";
import QuillEditor, { EditorContainer } from "./QuillEditor";
import { COLORS } from "styles/colors";

Quill.register("modules/imageActions", ImageActions);
Quill.register("modules/imageFormats", ImageFormats);

export const Wrapper = styled(EditorContainer)`
  color: ${COLORS.BLACK};

  /* 전역 strong(500) 오버라이드로 bold 차이가 약해지는 문제 방지 */
  .ql-editor strong,
  .ql-editor b {
    font-weight: 700 !important;
  }
`;

const modules = {
  imageActions: {},
  imageFormats: {},

  toolbar: [
    // container에 등록되는 순서대로 tool 배치
    // container: [
    // [{ font: [] }], // font 설정
    [{ header: [1, 2, 3, 4, 5, 6, false] }], // header 설정
    ["bold", "italic", "underline", "strike", "blockquote", "code-block"], // 굵기, 기울기, 밑줄 등 부가 tool 설정
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ align: [] }, { color: [] }, { background: [] }], // 정렬, 글씨 색깔, 글씨 배경색 설정
    // ["link", "image"],
    ["link", "clean"], // toolbar 설정 초기화 설정
    // ],
  ],
};

const formats = [
  "align",
  "background",
  "blockquote",
  "bold",
  "code-block",
  "color",
  "float",
  "font",
  "header",
  "height",
  // "image",
  "italic",
  "link",
  "list",
  "indent",
  "script",
  "strike",
  "size",
  "underline",
  "width",
];

function EmailEditor(props: ReactQuillProps): JSX.Element {
  return (
    <Wrapper id="email-editor-container">
      <QuillEditor
        bounds={"#email-editor-container"}
        modules={modules}
        formats={formats}
        {...props}
      />
    </Wrapper>
  );
}

export default EmailEditor;
